import styles from "./MiniTopContributors.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchTopContributors, resetContributors } from "../../store/slices/topContributorsSlice";
import { useEffect, useState } from "react";
import iconimg from "../../assets/images/iconplaceholder.png";
import countFiles from "../../assets/svg/countFiles.svg";
import arrowbtn from "../../assets/svg/arrowbtn.svg";
import { useNavigate, Link } from "react-router-dom";
import isReactSnap from "../../utils/isReactSnap";

const MiniTopContributors = () => {
  const [visibleSlides, setVisibleSlides] = useState(3);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { contributors, status, error } = useSelector(
    (state) => state.topContributors
  );
  const { isAuthenticated } = useSelector((state) => state.user);

  const updateVisibleSlides = () => {
    if (window.innerWidth < 450) {
      setVisibleSlides(1);
    } else if (window.innerWidth < 690) {
      setVisibleSlides(2);
    } else {
      setVisibleSlides(3);
    }
  };

  useEffect(() => {
    updateVisibleSlides();
    window.addEventListener("resize", updateVisibleSlides);
    return () => window.removeEventListener("resize", updateVisibleSlides);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isReactSnap) {
      return;
    }
    dispatch(resetContributors());
    dispatch(fetchTopContributors({ page: 1, pageSize: 12 }));
  }, [dispatch]);

  const handleNavigation = (id) => {
    navigate(`/profile/${id}`);
  };

  const contributorsData = contributors.slice(0, 12);
  const mobileSlides = Array.from({ length: 2 }, (_, i) =>
    contributorsData.slice(i * 6, i * 6 + 6)
  );

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % mobileSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + mobileSlides.length) % mobileSlides.length);
  };

  // Обработка свайпа
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextSlide();
    }
    if (isRightSwipe) {
      prevSlide();
    }
  };
  const truncate = (text, maxLength = 21) =>
    text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  return (
    <>
      {(status === "idle" || status === "loading") && <div style={{minHeight: '350px'}}></div>}
      {status === "succeeded" && (
        <div className={styles.topContribiutors}>
          {isMobile ? (
            <>
              <div className={styles.headerTop}>
                <h2 className="h2-bold">Top Contributors</h2>
              </div>

              <div 
                className={styles.sliderWrapper}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                <div className={styles.slideContent}>
                  <div className={styles.slidesContainer} style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                    {mobileSlides.map((slide, slideIndex) => (
                      <div key={slideIndex} className={styles.slide}>
                        <div className={styles.grid}>
                          {slide.map((item, index) => (
                            <Link
                              to={`/profile/${item.id}`}
                              key={index}
                              className={styles.userSmall}
                            >
                              <p className={styles.numberSmall}>{item.position}.</p>
                              <div className={styles.avatarSmallWrap}>
                                <img
                                  className={styles.avatarSmall}
                                  style={!item.profile_picture ? { transform: "scale(1.3)" } : undefined}
                                  src={item.profile_picture || iconimg}
                                  alt="icon"
                                />
                              </div>
                              <div className={styles.infoSmall}>
                               <p className={styles.nameSmall} title={item.username}>
                            {truncate(item.username)}
                          </p>
                                <div className={styles.countBlockSmall}>
                                  <img src={countFiles} alt="icon" />
                                  <p>{item.total_products}</p>
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Навигационные элементы под контентом */}
              <div className={styles.navigationWrapper}>
                <button className={styles.arrowLeft} onClick={prevSlide}>
                </button>

                <div className={styles.dotsContainer}>
                  {mobileSlides.map((_, index) => (
                    <div
                      key={index}
                      className={`${styles.dot} ${
                        index === currentSlide ? styles.activeDot : ''
                      }`}
                      onClick={() => setCurrentSlide(index)}
                    />
                  ))}
                </div>

                <button className={styles.arrowRight} onClick={nextSlide}>
                </button>
              </div>

              <Link to="/top-contributors" style={{ textDecoration: 'none' }}>
                <button style={{ height: '60px' }}
                  className={`${styles.allButton} ${styles.allButtonMobile}`}
                >
                  <span className={styles.allText}>See all</span>
                  <svg width="27" height="36" viewBox="0 0 27 36" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.707 11.9908L22.364 17.6478C22.5515 17.8354 22.6568 18.0897 22.6568 18.3548C22.6568 18.62 22.5515 18.8743 22.364 19.0618L16.707 24.7188C16.5184 24.901 16.2658 25.0018 16.0036 24.9995C15.7414 24.9972 15.4906 24.8921 15.3052 24.7067C15.1198 24.5212 15.0146 24.2704 15.0123 24.0082C15.01 23.746 15.1108 23.4934 15.293 23.3048L19.243 19.3548L6 19.3548C5.73478 19.3548 5.48043 19.2495 5.29289 19.0619C5.10536 18.8744 5 18.6201 5 18.3548C5 18.0896 5.10536 17.8353 5.29289 17.6477C5.48043 17.4602 5.73478 17.3548 6 17.3548L19.243 17.3548L15.293 13.4048C15.1975 13.3126 15.1213 13.2022 15.0689 13.0802C15.0165 12.9582 14.9889 12.827 14.9877 12.6942C14.9866 12.5615 15.0119 12.4298 15.0622 12.3069C15.1125 12.184 15.1867 12.0723 15.2806 11.9784C15.3745 11.8845 15.4861 11.8103 15.609 11.76C15.7319 11.7097 15.8636 11.6844 15.9964 11.6856C16.1292 11.6867 16.2604 11.7143 16.3824 11.7667C16.5044 11.8191 16.6148 11.8953 16.707 11.9908Z"></path></svg>
                </button>
              </Link>
            </>
          ) : (
            <>
              <div className={styles.headerTop}>
                <h2 className="h2-bold">Top Contributors</h2>
                <Link to="/top-contributors" style={{ textDecoration: 'none' }}>
                  <button className={styles.allButton}>
                    <span className={styles.allText}>See all</span>
                    <img src={arrowbtn} alt="icon" />
                  </button>
                </Link>
              </div>
              <div className={styles.topContainer}>
                {contributorsData.map((item, index) => (
                  <Link
                    to={`/profile/${item.id}`}
                    key={index}
                    className={styles.user}
                  >
                    <p className={styles.number}>{item.position}.</p>
                    <div style={{ width: "60px", height: "60px", borderRadius: "5px", overflow: "hidden", flexShrink: 0 }}>
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                          transform: item.profile_picture ? "none" : "scale(1.3)",
                        }}
                        src={item.profile_picture || iconimg}
                        alt="icon"
                      />
                    </div>
                    <div className={styles.info}>
                      <p className={styles.name}>{item.username}</p>
                      <div className={styles.countBlcok}>
                        <img src={countFiles} alt="icon" />
                        <p style={{ fontSize: "24px" }}>{item.total_products}</p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default MiniTopContributors;